export const LIST_REWARD = 'LIST_REWARD'
export const LIST_REWARD_INFINITE = 'LIST_REWARD_INFINITE'
export const CREATE_REWARD = 'CREATE_REWARD'
export const REMOVE_REWARD = 'REMOVE_REWARD'
export const DETAIL_REWARD = 'DETAIL_REWARD'
export const TOTAL_REWARD = 'TOTAL_REWARD'
